import React from "react"
import parse from "html-react-parser";

const sanitizeMessage = (message) => {
    return message.replace(/<([a-zA-Z0-9-]+)(\s[^>]*)?(?<!\/)>/g, (match, tagName) => {
      // Check if there's a valid closing tag
      const closingTag = new RegExp(`</${tagName}>`, "i");
  
      // Check if it's a self-closing tag
      const selfClosingTags = ["br", "img", "hr", "input", "meta", "link"];
      if (closingTag.test(message) || selfClosingTags.includes(tagName.toLowerCase())) {
        return match; // Keep valid HTML tags
      }
  
      return `&lt;${match.substring(1, match.length - 1)}&gt;`; // Escape invalid tags
    });
  };

function ConvertStringToHtml(props){
    return(<>{props.msg?parse(sanitizeMessage(props.msg)):""}</>)
}
export default ConvertStringToHtml